module.exports = __webpack_public_path__ + "static/media/cio_icon.5526f520.svg";